// extracted by mini-css-extract-plugin
export default {"prologWrap":"prolog_prologWrap__LiS35","prologTextBlock":"prolog_prologTextBlock__8g87V","prologVisible":"prolog_prologVisible__AFB9p","prologBtnWrap":"prolog_prologBtnWrap__xs0as"};